import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { pageSchemas } from "@/lib/seo/page-schema";
import { MediaAgenciesPersonaPageBG } from "@/components/site/MediaAgenciesPersonaPageBG";
import { MEDIA_AGENCIES_META_DESCRIPTION_BG } from "@/content/meta/MediaAgenciesPersonaPageBG";

export const Route = createFileRoute("/bg/who-we-help/media-agencies")({
  head: () => ({
    meta: [
      { title: "Медийно разузнаване за медийни агенции | Perceptica" },
      { name: "description", content: MEDIA_AGENCIES_META_DESCRIPTION_BG },

      { property: "og:title", content: "Медийно разузнаване за медийни агенции | Perceptica" },
      { property: "og:description", content: MEDIA_AGENCIES_META_DESCRIPTION_BG },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Медийно разузнаване за медийни агенции | Perceptica" },
      { name: "twitter:description", content: MEDIA_AGENCIES_META_DESCRIPTION_BG },
      { property: "og:url", content: "https://perceptica.com/bg/who-we-help/media-agencies" },
      ...ogImageMeta("bg", "/who-we-help/media-agencies"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/who-we-help/media-agencies" }),
  }),
  component: MediaAgenciesPersonaPageBG,
});
